import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import api from '../services/api';
import './WinnerModal.css';

function WinnerModal() {
  const { user } = useAuth();
  const [winner, setWinner] = useState(null);
  const [show, setShow] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    if (user && !dismissed) {
      checkForWinner();
    }
  }, [user, dismissed]);

  const checkForWinner = async () => {
    try {
      const data = await api.getOverallWinner();
      if (data.allWinnersSet && data.overallWinner) {
        // Check if we've already shown this
        const shownWinnerId = localStorage.getItem('shownWinnerId');
        if (shownWinnerId !== data.overallWinner.userId) {
          setWinner(data.overallWinner);
          setShow(true);
        }
      }
    } catch (error) {
      // Silently fail
    }
  };

  const handleDismiss = () => {
    if (winner) {
      localStorage.setItem('shownWinnerId', winner.userId);
    }
    setShow(false);
    setDismissed(true);
  };

  if (!show || !winner) return null;

  return (
    <div className="modal-overlay" onClick={handleDismiss}>
      <div className="modal winner-modal" onClick={(e) => e.stopPropagation()}>
        <div className="trophy-icon">
          <span role="img" aria-label="trophy">
            &#127942;
          </span>
        </div>
        <h2>We Have a Winner!</h2>
        <div className="winner-name">{winner.name}</div>
        <div className="winner-score">{winner.score} points</div>
        <p className="winner-message">
          Congratulations on winning the Oscar Predictions competition!
        </p>
        <button className="btn btn-primary" onClick={handleDismiss}>
          Awesome!
        </button>
      </div>
    </div>
  );
}

export default WinnerModal;
